import "../styles/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="portfolio-footer">
      <p className="footer-text copyright">
        &copy; {currentYear} Sailesh Kafle.
      </p>
      {/* <p className="footer-text handcrafted-by">
        Handcrafted with React &amp; Vanilla CSS.
      </p> */}
    </footer>
  );
};

export default Footer;
